import * as firebase from 'firebase';
import { InjectionToken } from '@angular/core';
import { CoreService, core } from '@mycure/sdk';
import io from 'socket.io-client';

export class MycureSDK extends CoreService { }

export function factory(value: any): MycureSDK {
  const fbApp = firebase.initializeApp(value.config);
  
  const uri = localStorage.getItem('syncbase:uri');
  // if has saved values, return as item
  const sdk: any = core.initialize(uri || value.base, { firebaseApp: fbApp, socketIOClient: io }) as MycureSDK;
  console.log('listening to socket events...')
  sdk.io.on('error', (error) => {
    console.error("SOCKET IO ERROR", error)
  });

  sdk.io.on('disconnect', (reason) => {
    console.error("SOCKET IO DC", reason)
  });

  sdk.io.on('reconnect_attempt', (reason) => {
    console.error("SOCKET IO RECON", reason)
  });

  sdk.io.on('reconnect_failed', (reason) => {
    console.error("SOCKET IO RECON FAILED", reason)
  });

  sdk.io.on('connect', (reason) => {
    console.error("SOCKET IO CONNECTED", reason)
  });

  sdk.io.on('connect_error', (reason) => {
    console.error("SOCKET IO CONNECT ERROR", reason)
  });
  
  
  return sdk;
}

export const MycureSDKConfigToken = new InjectionToken<any>('MycureSDKConfigToken');

export const SDKServiceProvider = {
  provide: MycureSDK,
  useFactory: factory,
  deps: [ MycureSDKConfigToken ]
};